<template>
    <div>
        <b-table-simple hover responsive>
            <b-thead>
                <b-th> {{$t('dealer.users.name')}} </b-th>
                <b-th> {{$t('dealer.users.mail')}} </b-th>
                <b-th> {{$t('dealer.users.phone')}} </b-th>
                <b-th> {{$t('dealer.users.task')}} </b-th>
                <b-th> {{$t('dealer.list.actions')}} </b-th>
            </b-thead>
            <b-tbody>
               <b-tr v-for="(user, index) in users " :key="index">
                    <b-td> {{user.name}} </b-td>
                    <b-td> {{user.email}} </b-td>
                    <b-td> {{user.phone_no}} </b-td>
                    <b-td> {{user.task && user.task.name}} </b-td>
                    <b-td>
                        <b-button size="sm" :title="$t('general.edit')" variant="primary"  @click="openModal('edit', user)"  > <b-icon icon="pencil-square" ></b-icon> </b-button> 
                        <b-button size="sm" :title="$t('general.delete')" variant="danger" @click="openModal('delete', user)" > <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </b-td>
               </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
        

</template>
               
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        name: "Users",
        computed:{
             users(){
                return this.$store.getters.getCompanyUsers
            },
        },
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
             openModal:function(name, data){
                this.modalType(true, 'CompanyUser')
                this.modalEvent(true, name, data)
            }
        },
        components:{
            Multiselect
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/userForm.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/components/Users.vue